import type { MeResponse } from "@hyphesync/shared";

/** Who sees what in the SPA. The API enforces every one of these; this only hides what would
 *  answer 403. Admin: everything (OD-31). Manager: Sync health, read-only (OD-33, OD-34). */
export const isAdmin = (me: MeResponse) => me.user.role === "admin" || me.user.isSuperAdmin;
export const canSeeSyncHealth = (me: MeResponse) => isAdmin(me) || me.user.role === "manager";
